import { CBadge, CButton, CFormSelect, CFormSwitch } from '@coreui/react-pro'
import React, { useState } from 'react'
import ToastComponent from 'src/components/common/TaostComponent'
import CommonService from 'src/service/CommonService'

const ShowEmailTemplate = (props) => {
  const [topTenRank, setTopTenRank] = useState([])
  const getTopTenManager = () => {
    CommonService.topTenRankData().then((res) => {
      if (res.status === 200) {
        setTopTenRank(res.data)
      }
    })
  }
  return (
    <>
      <table className="main-table table innertable">
        <thead>
          <tr>
            <th width="30%">Name</th>
            <th width="30%">Duration</th>
            <th width="30%">Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Fantasy Round Reminder</td>
            <td>
              <CFormSelect
                aria-label="Select Structure"
                name="templete_id_48"
                className="form-control"
                value={props.hourValue['48']}
                // onChange={handleChange}
                onChange={(e) => props.handleHourChange(e, '48')}
                id="structure"
              >
                <option value="">Set Hours (Before Round Starts) </option>
                {[...Array(24).keys()].map((num) => (
                  <option key={num + 1} value={num + 1}>
                    {num + 1}
                  </option>
                ))}
              </CFormSelect>
            </td>
            <td>
              <CFormSwitch
                size="lg"
                label={props.enableDisableStatus['48'] ? 'Enabled' : 'Disabled'}
                id="formSwitchCheckDefaultLg"
                checked={props.enableDisableStatus['48'] || false}
                onChange={(e) => props.handleEnableDisableChangeStatus(e, '48')}
              />
            </td>
            <td>
              <CButton onClick={() => props.handleSaveEmailNotificationSetting(48)}>Save</CButton>
            </td>
          </tr>
          <tr>
            <td>Fantasy Round Results & Reminder</td>
            <td>
              <CFormSelect
                aria-label="Select Structure"
                name="templete_id_50"
                className="form-control"
                value={props.hourValue['50']}
                onChange={(e) => props.handleHourChange(e, '50')}
                id="structure"
              >
                <option value="">Set Hours (After End of Round) </option>
                {[...Array(24).keys()].map((num) => (
                  <option key={num + 1} value={num + 1}>
                    {num + 1}
                  </option>
                ))}
              </CFormSelect>
            </td>
            <td>
              <CFormSwitch
                size="lg"
                label={props.enableDisableStatus['50'] ? 'Enabled' : 'Disabled'}
                id="formSwitchCheckDefaultLg11"
                checked={props.enableDisableStatus['50'] || false}
                onChange={(e) => props.handleEnableDisableChangeStatus(e, '50')}
              />
            </td>

            <td>
              <CButton onClick={() => props.handleSaveEmailNotificationSetting(50)}>Save</CButton>
            </td>
          </tr>
          <tr>
            <td>Top 10 Managers Reminder</td>
            <td>
              <CFormSelect
                aria-label="Select Structure"
                name="templete_id_50"
                className="form-control"
                value={props.hourValue['50']}
                onChange={(e) => props.handleHourChange(e, '50')}
                id="structure"
              >
                <option value="">Set Hours (After End of Round) </option>
                {[...Array(24).keys()].map((num) => (
                  <option key={num + 1} value={num + 1}>
                    {num + 1}
                  </option>
                ))}
              </CFormSelect>
            </td>
            <td>
              <CFormSwitch
                size="lg"
                label={props.enableDisableStatus['50'] ? 'Enabled' : 'Disabled'}
                id="formSwitchCheckDefaultLg11"
                checked={props.enableDisableStatus['50'] || false}
                onChange={(e) => props.handleEnableDisableChangeStatus(e, '50')}
              />
            </td>

            <td>
              <CButton onClick={() => props.handleSaveEmailNotificationSetting(50)}>Save</CButton>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default ShowEmailTemplate
